import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getSellerId } from "../../utils/api";

const ProductFilterModal = ({
    open,
    onClose,
    filters,
    setFilters,
    filterConfig,
    onApply
}) => {

    const [options, setOptions] = useState({});

    useEffect(() => {
        if (!open) return;

        const loadFilters = async () => {
            try {
                const seller = getSellerId();

                const results = await Promise.all(
                    filterConfig.map(f => f.api(seller))
                );

                const mapped = {};

                filterConfig.forEach((f, i) => {
                    mapped[f.key] = results[i]?.data || [];
                });

                setOptions(mapped);

            } catch (err) {
                console.error("Filter load failed", err);
            }
        };

        loadFilters();
    }, [open, filterConfig]);

    const getOptions = (key) => {
        const data = options?.[key];
        return Array.isArray(data) ? data : [];
    };

    if (!open) return null;

    return (
        <div className="filter-popup-overlay" onClick={onClose}>
            <div
                className="filter-popup"
                onClick={(e) => e.stopPropagation()}
            >
                <h3>Filters</h3>

                {filterConfig.map((filter) => (
                    <div key={filter.key} className="filter-group">

                        <label>{filter.label}</label>

                        <Select
                            options={getOptions(filter.key).map(o => ({
                                value: o.id,
                                label: o.name
                            }))}

                            value={
                                filters?.[filter.key]
                                    ? {
                                        value: filters[filter.key].id,
                                        label: filters[filter.key].name
                                    }
                                    : null
                            }

                            onChange={(selected) =>
                                setFilters(prev => ({
                                    ...prev,
                                    [filter.key]: selected
                                        ? { id: selected.value, name: selected.label }
                                        : null
                                }))
                            }

                            isClearable
                            isSearchable
                            placeholder={`Select ${filter.label}`}
                        />

                    </div>
                ))}

                <div className="filter-actions">
                    <button
                        className="btn-secondary"
                        onClick={() => {
                            const cleared = {};
                            filterConfig.forEach(f => {
                                cleared[f.key] = null;
                            });
                            setFilters(cleared);
                            onClose();
                        }}
                    >
                        Clear
                    </button>

                    <button
                        className="btn-primary"
                        onClick={() => {
                            onApply();
                            onClose();
                        }}
                    >
                        Apply
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProductFilterModal;